module.exports = __webpack_public_path__ + "static/BT-desktop-3-5be0c2fd1d71bf70eca8f811aced57a1.jpg";